import React, { useState, Fragment, useContext } from "react";
import { useFsideBar } from "./hooks/useFtopBar";
import "./style/FTopBar.css";
import { Menu, Transition } from "@headlessui/react";
import { ArrowCircleDownIcon, ArrowCircleUpIcon, BellIcon, MenuAlt2Icon } from "@heroicons/react/outline";
import { PlusIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router";
import FNotificationCard from "../FNotificationCard/FNotificationCard";
import { Link, useLocation } from "react-router-dom";
import FNavigator from "../FNavigator/FNavigator";
import { AuthContext } from "../../context/AuthContext";
import { getProfilePicture } from "../../api/auth";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";

import {
  PeopleOutline,
  ShareSocialOutline,
  Notifications,
  NotificationsOutline,
  Close
} from "react-ionicons";
import { useNotification } from "../../hooks/useNotification";
import { EffectCoverflow, Pagination } from "swiper";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
// import required modules

const userNavigation = [
  {
    title: "Te han enviado dinero",
    message: "Has recibido un Fiado de 30!",
    view: false,
  },
];

const FtopBar = (props) => {
  const { setNavigation, navigation, profilePicture, setProfilePicture, totalPending, setTotalPending } =
    useContext(AuthContext);
  const sampleLocation = useLocation();
  const token = localStorage.getItem("token");
  const tokenDecode = jwt_decode(token);
  const route = useNavigate();

  const setNavigationFunc = () => {
    console.log(sampleLocation);

    let navigationFluxes = [
      //HOME FLUX
      { route: "/", previousScreen: "/", flux: "Home" },
      //PIDE FLUX
      { route: "/CalcScreen", previousScreen: "/", flux: "Pide" },
      {
        route: "/PaymentMethodScreen",
        previousScreen: "/CalcScreen",
        flux: "Pide",
      },
      {
        route: "/",
        previousScreen: "/PaymentMethodScreen",
        previousState: sampleLocation.state,
        flux: "Pide",
      },
      {
        route: "/CheckScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },
      {
        route: "/ZellePaymentScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },
      {
        route: "/CodiPaymentScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },
      {
        route: "/StorePaymentScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },
      {
        route: "/ArcusPaymentScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },
      {
        route: "/BankPaymentScreen",
        previousScreen: "/PaymentMethodScreen",
        flux: "Pide",
      },

      //GASTA FLUX
      { route: "/MainScreen", previousScreen: "/", flux: "Gasta" },
      {
        route: "/RechargeScreen",
        previousScreen: "/MainScreen",
        flux: "Gasta",
      },
      {
        route: "/RechargeOptionScreen",
        previousScreen: "/RechargeScreen",
        flux: "Gasta",
      },
      {
        route: "/AmountDropdownListScreen",
        previousScreen: "/RechargeScreen",
        flux: "Gasta",
      },
      {
        route: "/2",
        previousScreen: "/RechargeScreen",
        flux: "Gasta",
      },
      {
        route: "/ConsultAccountScreen",
        previousScreen: "/BillPaymentScreen",
        flux: "Gasta",
      },
      {
        route: "/BillPaymentScreen",
        previousScreen: "/BillPaymentScreen",
        flux: "Gasta",
      },
      {
        route: "/GiftCardScreen",
        previousScreen: "/BillPaymentScreen",
        flux: "Gasta",
      },

      //Comparte
      { route: "/ShareFiadoScreen", previousScreen: "/", flux: "Compartir" },
      { route: "/ApplyForScreen", previousScreen: "/", flux: "Solicitar" },
      {
        route: "/NotRegistredScreen",
        previousScreen: "/",
        flux: "Enviar Link",
      },

      //kYC
      {
        route: "/MenuKycScreen",
        previousScreen: "/",
        flux: "",
      },

      //Notificaciones
      {
        route: "/NotificationScreen",
        previousScreen: "/",
        flux: "Notificaciones",
      },
      {
        route: "/NotificationDetailScreen",
        previousScreen: "/",
        flux: "Notificaciones",
      },
    ];

    //Select from navigation stack
    let flux = navigationFluxes.filter(
      (flux) => flux.route == sampleLocation.pathname
    )[0];
    console.log(flux);

    setNavigation({
      flux: flux?.flux,
      actualScreen: flux?.route,
      previousScreen: flux?.previousScreen,
      previousState: flux?.previousState,
    });
  };

  const { getNotification, notifications } = useNotification();

  useEffect(() => {
    const _getNotification = async () => {
      let res = await getNotification("PENDING", 1, false)
      if (res[0]) {
        setTotalPending(res[1].totalRecords)
      } else {
        setTotalPending(0)
      }
    };
    _getNotification();
    getPicture();
  }, []);




  const getPicture = async () => {
    try {
      const { data } = await getProfilePicture();
      const imageBase64 = data.data.profilePicture;
      //console.log(data.data.profilePicture)
      setProfilePicture(`data:image/gif;base64,${imageBase64}`);
      return true;
    } catch (e) {
      console.log(e.response);
      return false;
    }
  };

  useEffect(() => {
    setNavigationFunc();
  }, [sampleLocation]);


  const { notificationsSocket, setNotificationsSocket } = useContext(AuthContext);
  const [_notifications, set_notifications] = useState([]);

  useEffect(() => {
    if (!!notificationsSocket) {
      const _getNotification = async () => {
        let res = await getNotification("PENDING", 1, false)
        if (res[0]) {
          setTotalPending(res[1].totalRecords)
        } else {
          setTotalPending(0)
        }
      };
      _getNotification();
      
      if (notificationsSocket.messageType === 'PUSH_RECIEVE_MONEY' || 
      notificationsSocket.messageType === 'REQUEST_FIADO_SHARE' ||
      notificationsSocket.messageType === 'REQUEST_FIADO_SHARE_REJECTED' ||
      notificationsSocket.messageType === 'BENEFICIARY_REQUEST_FIADO_SHARE' ||
      notificationsSocket.messageType === 'FIADO_PAYMENT_CONFIRM'
      ){
        set_notifications(_notifications.concat([notificationsSocket]))
        setNotificationsSocket(null)
      }
    }
  }, [notificationsSocket]);

  const [_notificationsDelete, set_notificationsDelete] = useState([]);

  return (
    <>
      <div className="md:pl-64 flex flex-col border-0 border-black">
        <div className="sticky top-0 z-20 flex-shrink-0 flex h-16 bg-white shadow ">
          <div className="flex-1 px-4 flex justify-between content-center items-center">
            <div className="">
              <div>
                {sampleLocation.pathname == "/" ? (
                  <>
                    <img
                      className="float-left inline-block sm:h-10 sm:w-10 rounded-full mt-1 md:hidden profile-picture"
                      src={
                        !profilePicture
                          ? require("../../components/assets/images/profile.png")
                          : profilePicture
                      }
                    />
                    <div className="bg-[#56b365] absolute w-[15px] h-[15px] md:hidden border-white border-[3px] ml-[28px] rounded-full"></div>
                    <div className="float-left font-semibold mt-[12px] ml-2 text-[13px] sm:text-[15px] md:hidden border-0">
                      {tokenDecode.preferredName.split(" ")[0]}
                    </div>
                  </>
                ) : (
                  <FNavigator
                    reverse={navigation.flux == "Home" ? false : true}
                  />
                )}
              </div>
            </div>
            {/* {sampleLocation.pathname == "/" ? ( */}
              <div className="ml-4 flex items-center md:ml-6">
                <div className="float-left sm:mx-2 cursor-pointer">
                  <div className="w-[25px] h-[25px] sm:w-[35px] sm:h-[35px]">
                    <PeopleOutline
                      color={"#F10C8F"}
                      cssClasses="!w-full !h-full"
                      onClick={() => {
                        route("/GroupScreen");
                      }}
                    />
                  </div>
                </div>
                <div className="float-left sm:mx-2 cursor-pointer border-0">
                  <div className="w-[25px] h-[25px] sm:w-[35px] sm:h-[35px]">
                    <ShareSocialOutline
                      color={"#F10C8F"}
                      cssClasses="!w-full !h-full"
                      onClick={() => route("/ReferalScreen")}
                    />
                  </div>
                </div>
                <div className="float-left sm:mx-2 cursor-pointer">
                  <div className="float-left inline-block w-[25px] h-[25px] sm:w-[35px] sm:h-[35px] border-0">
                    {
                      totalPending > 0 ? (
                        <Notifications
                          color={"#F10C8F"}
                          cssClasses="!w-full !h-full"
                          onClick={() => route("/NotificationScreen")}
                        />
                      ) : (
                        <NotificationsOutline
                          color={"#F10C8F"}
                          cssClasses="!w-full !h-full"
                          onClick={() => route("/NotificationScreen")}
                        />
                      )
                    }

                  </div>
                </div>
              </div>
            {/* ) : null} */}
          </div>

          <div className="absolute border-0 -right-0  mt-[70px]">
            {_notifications.length > 0 ? _notifications.map((notification, index) => {

              return (
                <div className={`hideMe ${_notificationsDelete.includes(notification.id) ? "hidden" : ""}`}>
                  <>
                    <Swiper
                      effect={"coverflow"}
                      grabCursor={true}
                      centeredSlides={true}
                      slidesPerView={1}
                      edgeSwipeThreshold={20}
                      coverflowEffect={{
                        rotate: 10,
                        stretch: 15,
                        depth: 150,
                        modifier: 3,
                        slideShadows: false,
                      }}
                      loop={true}
                      modules={[EffectCoverflow, Pagination]}
                      className="absolute w-[360px] h-full border-0"
                      onSlideChange={(e) => {
                        if (e.realIndex == 1) {
                          set_notificationsDelete(_notificationsDelete.concat([notification.id]))
                        }
                      }}
                    >
                      <SwiperSlide>
                        <div >
                          <div className={`border-0 w-[350px] animated cursor-pointer fadeInRight `} onClick={() => {
                            if(notification.messageType === 'FIADO_PAYMENT_CONFIRM'){

                            } else{
                              route("/NotificationScreen")
                            }
                           
                            set_notifications([])
                          }}>
                            <div class="bg-white rounded-lg border-gray-300 border p-3 shadow-lg my-1">
                              <div class="flex flex-row">
                                <div class="px-2">
                                  {notification.messageType === 'PUSH_RECIEVE_MONEY' ? <ArrowCircleDownIcon className="!h-[24px] !w-[24px] border-0" color={'#2A9F52'} /> : null}
                                  {notification.messageType === 'REQUEST_FIADO_SHARE' ? <ArrowCircleUpIcon className="!h-[24px] !w-[24px] border-0" color={'#E30000'} /> : null}
                                  {notification.messageType === 'REQUEST_FIADO_SHARE_REJECTED' ? <ArrowCircleUpIcon className="!h-[24px] !w-[24px] border-0" color={'#E30000'} /> : null}
                                  {notification.messageType === 'BENEFICIARY_REQUEST_FIADO_SHARE' ? <ArrowCircleUpIcon className="!h-[24px] !w-[24px] border-0" color={'#E30000'} /> : null}
                                </div>
                                <div class="ml-2 mr-6">
                                  <span class="font-semibold text-[14px]">{
                                  !notification.message.header ? "" : notification.message.header == "null" ? "" : notification.message.header
                                  }</span>
                                  <span class="block text-gray-500 text-[13px]">{
                                  !notification.message.body ? "" : notification.message.body == "null" ? "" : notification.message.body
                                  }</span>
                                </div>
                                <Close className="!h-[24px] !w-[24px] border-0 z-10" color={'#9E9E9E'} onClick={() => {
                                  set_notificationsDelete(_notificationsDelete.concat([notification.id]))
                                }} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="mx-20">
                          <div className={`border-0 w-[350px] animated cursor-pointer fadeInRight `}>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </>
                </div>
              )
            }) : null}

          </div>
        </div>
        {props.children}
      </div>

    </>


  );
};

export default FtopBar;
